"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storage_blob_1 = require("@azure/storage-blob");
var dexie_db_1 = __importDefault(require("./dexie-db"));
var PreviewAccess_1 = __importDefault(require("./PreviewAccess"));
var SounditiApi_1 = __importDefault(require("../SounditiApi"));
var defaults_1 = __importDefault(require("../defaults"));
var AuthTester_1 = __importDefault(require("../AuthTester"));
var errors_1 = require("../utils/errors");
var logger_1 = __importDefault(require("../utils/logger"));
var fetch_progress_1 = __importDefault(require("fetch-progress"));
var logger = logger_1.default('testerAccess');
/**
 * Provides access to the tester actions
 * It should be used in companion with {@link TesterAuth}
 *
 * When in preview mode it will return null for all methods except for
 * getCampaign()
 * getFile(fileName)
 *
 * More info to use the preview mode here {@link PreviewAccess}
 *
 * @class
 *
 * @param {string} [isPreview = false] mode selection
 * @param {string} [previewToken = ''] a preview access token
 * @param {string} token | the api host
 * @param {string} [hosts = defaults] | the api host
 *
 * @category ClientDataLayers
 *
 * @example
 * //ONCE THE USER IS LOGGED IN WITH {@link TesterAuth}
 *  const testerAccess  = new TesterAccess()
 *  const profile = await testerAccess.getProfile()
 *
 *
 * //PREVIEW MODE
 * const previewToken = 'OBTAINED WITH CAMPAIGNACCESS';
 * const testerAccessInPreview = new TesterAccess(true,previewToken)
 */
var TesterAccess = /** @class */ (function () {
    /**
     *
     * @param {DataLayerConfiguration} options
     * @param {token} options.token An access token
     * @param {host} [options.host = defaults.host] An access token
     *
     */
    function TesterAccess(isPreview, previewToken, options) {
        if (isPreview === void 0) { isPreview = false; }
        if (previewToken === void 0) { previewToken = null; }
        var hosts = __assign(__assign({}, defaults_1.default), options);
        this.auth = new AuthTester_1.default(options);
        this.token = this.auth.getToken() || '';
        this.api = new SounditiApi_1.default({ token: this.token, hosts: hosts });
        this.previewAccess = new PreviewAccess_1.default({ token: previewToken, hosts: hosts });
        this.isPreview = isPreview;
    }
    /**
     * Gets tester profile data for authenticated user
     *
     * @returns {Promise<TesterItem>} A tester item. If is preview, it returns {userId: 'preview-user'}
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.getProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        return [2 /*return*/, { userId: 'preview-user' }];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.getTester()];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res.json()];
                    case 3:
                        error_1 = _a.sent();
                        throw new errors_1.PermissionError(error_1.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates tester profile data
     *
     * @param {object} data The public tester data to update
     *
     * @returns {Promise<TesterItem>} A tester item
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.updateProfile = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        return [2 /*return*/, null];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.updateTester(data)];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res.json()];
                    case 3:
                        error_2 = _a.sent();
                        throw new errors_1.PermissionError(error_2.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets the campaign public data using the testerToken
     *
     * @returns {object} Campaign data
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.getCampaign = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        logger.info('isPreview getCampaign');
                        return [2 /*return*/, this.previewAccess.getCampaign()];
                    case 1:
                        logger.info('getCampaign');
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.api.getTesterCampaign()];
                    case 3:
                        res = _a.sent();
                        return [2 /*return*/, res.json()];
                    case 4:
                        error_3 = _a.sent();
                        throw new errors_1.PermissionError(error_3.message);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a campaign file from the campaigns storage account using the testerToken
     *
     * @param {string} fileName The name of the file
     *
     * @returns {Promise<SAS>}  Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.getFile = function (fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var res, sas, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        logger.info('isPreview getFile');
                        return [2 /*return*/, this.previewAccess.getFile(fileName)];
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        logger.info('getfile', { fileName: fileName });
                        return [4 /*yield*/, this.api.getTesterFile(fileName)];
                    case 2:
                        res = _a.sent();
                        logger.info('res', { res: res });
                        if (!(res.status === 200)) return [3 /*break*/, 4];
                        return [4 /*yield*/, res.json()];
                    case 3:
                        sas = _a.sent();
                        return [2 /*return*/, sas];
                    case 4: throw new errors_1.PermissionError('Invalid access token');
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_4 = _a.sent();
                        logger.error('getFile', { error: error_4 });
                        throw new errors_1.PermissionError(error_4.message);
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Test method for preloading assets in the indexedDB local storage
     * it tries to retrieve the file from local or dowload and stores the assets.
     * either way returns a local blob url.
     *
     * @param {string} fileName
     * @param {function} progress A callback function with the progress
     *
     * @returns {Promise<SAS>}  Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.getOfflineFile = function (fileName, progress) {
        return __awaiter(this, void 0, void 0, function () {
            var blob_1, blobFromDb, error_5, res, sas, error_6, blobURL;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        logger.info('isPreview getFile');
                        return [2 /*return*/, this.previewAccess.getOfflineFile(fileName)];
                    case 1:
                        blobFromDb = [];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').where('fileName').equals(fileName).toArray()];
                    case 3:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_5 = _a.sent();
                        console.log('getOfflineFile db error 1', error_5);
                        return [3 /*break*/, 5];
                    case 5:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 13];
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 11, , 12]);
                        return [4 /*yield*/, this.api.getTesterFile(fileName)];
                    case 7:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 10];
                        return [4 /*yield*/, res.json()];
                    case 8:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas.uri).then(fetch_progress_1.default({
                                onProgress: function (e) {
                                    if (progress)
                                        progress(e);
                                },
                            })).then(function (res2) { return res2.blob(); }).then(function (blobResponse) { return __awaiter(_this, void 0, void 0, function () {
                                var fileItem, error_7;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            blob_1 = blobResponse;
                                            fileItem = {
                                                id: fileName,
                                                fileName: fileName,
                                                storedAt: Date.now(),
                                                blob: blob_1
                                            };
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, dexie_db_1.default.table('files').put(fileItem)];
                                        case 2:
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_7 = _a.sent();
                                            console.log('getOfflineFile db error 2', error_7);
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_6 = _a.sent();
                        console.log('getOfflineFile error', { error: error_6 });
                        throw new Error(error_6.message);
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        blob_1 = blobFromDb[0].blob;
                        _a.label = 14;
                    case 14: return [4 /*yield*/, URL.createObjectURL(blob_1)];
                    case 15:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    /**
     * Test method for preloading assets in the indexedDB local storage
     * it tries to retrieve the file from local or dowload and stores the assets.
     * either way returns a local blob url.
     *
     * @param {string} fileName
     * @param {function} progress A callback function with the progress
     *
     * @returns {Promise<SAS>}  Shared access credentials
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.getOfflineFilmFile = function (getOfflineFilmFileRequest, progress) {
        return __awaiter(this, void 0, void 0, function () {
            var fileName, linkUrl, compressed, id, blob_2, blobFromDb, error_8, res, sas, error_9, blobURL;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileName = getOfflineFilmFileRequest.fileName, linkUrl = getOfflineFilmFileRequest.linkUrl, compressed = getOfflineFilmFileRequest.compressed;
                        id = linkUrl ? fileName + '-' + linkUrl : compressed ? fileName + '-compressed' : fileName;
                        if (!this.isPreview) return [3 /*break*/, 1];
                        logger.info('isPreview getFile');
                        return [2 /*return*/, this.previewAccess.getOfflineFilmFile(getOfflineFilmFileRequest, progress)];
                    case 1:
                        blobFromDb = [];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, dexie_db_1.default.table('files').where('fileName').equals(id).toArray()];
                    case 3:
                        blobFromDb = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_8 = _a.sent();
                        console.log('getOfflineFilmFile db error 1', error_8);
                        return [3 /*break*/, 5];
                    case 5:
                        if (!(blobFromDb.length === 0)) return [3 /*break*/, 13];
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 11, , 12]);
                        return [4 /*yield*/, this.api.getTesterFilmFile(getOfflineFilmFileRequest)];
                    case 7:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 10];
                        return [4 /*yield*/, res.json()];
                    case 8:
                        sas = _a.sent();
                        return [4 /*yield*/, fetch(sas[0]).then(fetch_progress_1.default({
                                onProgress: function (e) {
                                    if (progress)
                                        progress(e);
                                },
                            })).then(function (res2) { return res2.blob(); }).then(function (blobResponse) { return __awaiter(_this, void 0, void 0, function () {
                                var fileItem, error_10;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            blob_2 = blobResponse;
                                            fileItem = {
                                                id: id,
                                                fileName: id,
                                                storedAt: Date.now(),
                                                blob: blob_2
                                            };
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, dexie_db_1.default.table('files').put(fileItem)];
                                        case 2:
                                            _a.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            error_10 = _a.sent();
                                            console.log('getOfflineFilmFile db error 2', error_10);
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_9 = _a.sent();
                        console.log('getOfflineFilmFile error', { error: error_9 });
                        throw new errors_1.PermissionError(error_9.message);
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        blob_2 = blobFromDb[0].blob;
                        _a.label = 14;
                    case 14: return [4 /*yield*/, URL.createObjectURL(blob_2)];
                    case 15:
                        blobURL = _a.sent();
                        return [2 /*return*/, { token: 'none', uri: blobURL }];
                }
            });
        });
    };
    ;
    /**
     * Helper function to upload a file and create an interaction object at the same time.
     * It uses azureBlobStorage library for upload process, the name of the file used for the interaction
     * post a file to storage and attach the interaction data if success.
     *
     * @param {File} file The file for the interaction
     * @param {moduleId} moduleId The id of the module
     * @param {interactionId} interactionId The id of the interaction
     *
     * @returns {Promise<NewInteractionResponse>} A sucessfull post returns nothing
     *
     * @throws {PermissionError} 403 responses or bad token
     * @throws {UploadError} Error when uploading the file
     */
    TesterAccess.prototype.createInteraction = function (file, moduleId, interactionId, sessionId, createdAt) {
        return __awaiter(this, void 0, void 0, function () {
            var res, _a, token, uri, blockblobService, upload, interactionResponse, newInteraction, error_11, error_12;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        return [2 /*return*/, null];
                    case 1:
                        _b.trys.push([1, 11, , 12]);
                        return [4 /*yield*/, this.api.postSASTesterFile(file.name)];
                    case 2:
                        res = _b.sent();
                        logger.debug('Res', { res: res });
                        return [4 /*yield*/, res.json()];
                    case 3:
                        _a = _b.sent(), token = _a.token, uri = _a.uri;
                        logger.debug('BlobUri', { token: token, uri: uri });
                        blockblobService = new storage_blob_1.BlockBlobClient(uri);
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 9, , 10]);
                        return [4 /*yield*/, blockblobService.uploadData(file, {
                                maxSingleShotSize: 4 * 1024 * 1024
                            })];
                    case 5:
                        upload = _b.sent();
                        if (!(upload._response.status === 201)) return [3 /*break*/, 7];
                        interactionResponse = this.api.postInteraction(file.name, moduleId, interactionId, sessionId, createdAt);
                        return [4 /*yield*/, interactionResponse];
                    case 6:
                        newInteraction = (_b.sent()).json();
                        return [2 /*return*/, newInteraction];
                    case 7: throw new errors_1.UploadError('There was an upload error');
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        error_11 = _b.sent();
                        throw new errors_1.UploadError('There was an upload error');
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        error_12 = _b.sent();
                        logger.error('Upload error', { error: error_12 });
                        throw new errors_1.UploadError(error_12.message);
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Creates a mew interacation object without file upload
     * IMPORTANT: a fileName should be specified and loaded using another method.
     *
     * @param {string} fileName the name of the file to be reference later (should be unique)
     * @param {string} moduleId the moduleId to which the interaction belongs
     * @param {string} interactionId the interactionId to which the interaction belongs
     *
     * @returns {Promise<NewInteractionResponse>} TODO: a sucessfull post returns nothing
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.postInteractionData = function (fileName, moduleId, interactionId, sessionId, createdAt) {
        return __awaiter(this, void 0, void 0, function () {
            var interactionResponse, newInteraction, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        return [2 /*return*/, null];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        interactionResponse = this.api.postInteraction(fileName, moduleId, interactionId, sessionId, createdAt);
                        return [4 /*yield*/, interactionResponse];
                    case 2:
                        newInteraction = (_a.sent()).json();
                        return [2 /*return*/, newInteraction];
                    case 3:
                        error_13 = _a.sent();
                        throw new errors_1.PermissionError(error_13.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Gets a SAS access token for posting a file into the interaction Storage.
     * IMPORTANT: use with postInteractionData to create a new interaction
     * @param {string} fileName
     *
     * @returns {Promise<SAS>} Shared access credentials
     *
     * @throws {UploadError} Error when uploading the file
     */
    TesterAccess.prototype.postInteractionSAS = function (fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        return [2 /*return*/, null];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.postSASTesterFile(fileName)];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res.json()];
                    case 3:
                        error_14 = _a.sent();
                        logger.error('Upload error', { error: error_14 });
                        throw new errors_1.UploadError(error_14.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Uploads a tester action for posterior analisys and data visualization
     * It never throws as we only want to put data on the server
     *
     * @param {string} type The type of action
     * @param {string} moduleId The moduleId to which the interaction belongs
     * @param {string} interactionId The interactionId to which the interaction belongs
     * @param {string} device The device type: mobile or desktop
     * @param {string} browser The browser used
     * @param {string} sessionId The session identifier
     * @param {string} createdAt The timestamp when the action was created
     *
     * @returns {Promise<NewActionResponse>} TODO: should return nothing in production.
     *
     */
    TesterAccess.prototype.postAction = function (type, moduleId, interactionId, device, browser, sessionId, createdAt, filmTime, data) {
        if (device === void 0) { device = null; }
        if (browser === void 0) { browser = null; }
        if (sessionId === void 0) { sessionId = null; }
        if (createdAt === void 0) { createdAt = null; }
        if (filmTime === void 0) { filmTime = null; }
        if (data === void 0) { data = null; }
        return __awaiter(this, void 0, void 0, function () {
            var res, newInteraction, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        return [2 /*return*/, null];
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.api.postAction(type, moduleId, interactionId, device, browser, sessionId, createdAt, filmTime, data)];
                    case 2:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 3:
                        newInteraction = _a.sent();
                        return [2 /*return*/, newInteraction];
                    case 4:
                        error_15 = _a.sent();
                        throw error_15;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Adds a response to a question for a QA module:
     * <ul style="list-style: none;">
     * <li>1 - When the tester read a question set ansew = {{READ}}
     * <li>2 - When the tester replies to a question set answer to the answer full string
     * </ul>
     *
     * The analytics service will count READS and ANSWER based solely on this values.
     *
     * @param {string} type the type of action
     * @param {string} moduleId the moduleId to which the interaction belongs
     * @param {string} interactionId the interactionId to which the interaction belongs
     * @param {number} q_id the QA id, it should be a number (for example, a TimeStamp)
     * @param {string} question full text of the question
     * @param {string} [answer = "{{READ}}"] full text of the answer | Mark as "{{READ}}" to read actions
     *
     * @returns {Promise<NewActionResponse>} TODO: should return nothing in production
     *
     */
    TesterAccess.prototype.postQuestion = function (moduleId, interactionId, q_id, question, answer, sessionId, createdAt) {
        if (answer === void 0) { answer = "{{READ}}"; }
        return __awaiter(this, void 0, void 0, function () {
            var res, newInteraction, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isPreview) return [3 /*break*/, 1];
                        return [2 /*return*/, null];
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.api.postQuestionAction(moduleId, interactionId, q_id, question, answer, sessionId, createdAt)];
                    case 2:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 3:
                        newInteraction = _a.sent();
                        return [2 /*return*/, newInteraction];
                    case 4:
                        error_16 = _a.sent();
                        throw error_16;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Gets a link object giving the link url
     *
     * @param {string} linkUrl The link url
     *
     * @returns {Promise<Link>} The links list of a campaign
     *
     * @throws {PermissionError} 403 responses or bad token
     */
    TesterAccess.prototype.getLinkByUrl = function (linkUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var res, link, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.getLinkByUrl(linkUrl)];
                    case 1:
                        res = _a.sent();
                        return [4 /*yield*/, res.json()];
                    case 2:
                        link = _a.sent();
                        return [2 /*return*/, link];
                    case 3:
                        error_17 = _a.sent();
                        throw new Error(error_17);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return TesterAccess;
}());
;
exports.default = TesterAccess;
//# sourceMappingURL=TesterAccess.js.map